export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7667.2e5f9dde.jpg";